import { toaster } from 'evergreen-ui';
import { normalizeTime } from '../../utils/timeUtils';

// Da usare negli onBlur dei campi orario libero (turni, ferie, orario fisso,
// reperibilità, intervalli notte attiva). normalizeTime rigetta silenziosamente
// (stringa vuota) i formati non riconosciuti o fuori range: qui avvisiamo
// l'utente prima di svuotare il campo, così capisce perché il testo è sparito.
// Un campo già vuoto non genera avviso: è uno svuotamento intenzionale, non un errore.
export const normalizeTimeInput = (val) => {
  const normalized = normalizeTime(val);
  const wasEmpty = String(val ?? '').trim() === '';
  if (normalized === '' && !wasEmpty) {
    toaster.warning('Formato orario non valido, campo svuotato');
  }
  return normalized;
};
